const R = 110, C = 150;
const pt = (h, r = R) => {
  const a = ((h % 12) * 30 - 90) * (Math.PI / 180);
  return [C + r * Math.cos(a), C + r * Math.sin(a)];
};

export const RimClockSvg = () => {
  const [x3, y3] = pt(3), [x4, y4] = pt(4);
  const [sx, sy] = pt(6, 140), [tx, ty] = pt(12);
  return (
    <svg viewBox="0 0 300 300" className="w-full h-auto" data-testid="rim-clock-svg" role="img" aria-label="Rim clock diagram">
      <rect x={C - 70} y="2" width="140" height="8" fill="#94a3b8" />
      <text x={C + 76} y="10" fontSize="9" fontWeight="700" fill="#475569">Backboard</text>
      <circle cx={C} cy={C} r={R} fill="#fff7ed" stroke="#ea580c" strokeWidth="6" />
      <line x1={sx} y1={sy} x2={tx} y2={ty} stroke="#2563eb" strokeWidth="2" strokeDasharray="6 4" />
      <path d={`M${C},${C} L${x3},${y3} A${R},${R} 0 0 1 ${x4},${y4} Z`} fill="#22c55e33" stroke="#16a34a" strokeWidth="1.5" />
      <text x={C + 38} y={C + 24} fontSize="11" fontWeight="700" fill="#15803d">30°</text>
      {Array.from({ length: 12 }, (_, i) => i + 1).map((h) => {
        const [hx, hy] = pt(h), [lx, ly] = pt(h, R + 20);
        return (
          <g key={h}>
            <circle cx={hx} cy={hy} r="5" fill="#111" />
            <text x={lx} y={ly + 4} fontSize="13" fontWeight="800" textAnchor="middle" fill="#111">{h}</text>
          </g>
        );
      })}
      <text x={C + 18} y={C - R + 16} fontSize="9" fontWeight="700" fill="#9a3412">back iron</text>
      <text x={C + 18} y={C + R - 10} fontSize="9" fontWeight="700" fill="#9a3412">front rim</text>
      <circle cx={C} cy={C} r="4" fill="#111" />
      <text x={C + 6} y={C - 6} fontSize="10" fontWeight="700" fill="#111">O (center)</text>
      <text x={C - 104} y={C - 34} fontSize="10" fill="#2563eb" fontWeight="700">aim line = diameter</text>
      <text x={C - 104} y={C - 22} fontSize="10" fill="#2563eb">18 in</text>
      <circle cx={sx} cy={Math.min(sy, 292)} r="6" fill="#2563eb" />
      <text x={sx + 10} y={Math.min(sy, 292)} fontSize="10" fontWeight="700" fill="#2563eb">Shooter</text>
    </svg>
  );
};

export const RimClockDiagram = ({ photoUrl }) => (
  <div className="mb-5 border-2 border-orange-500 bg-orange-50 p-4" data-testid="rim-clock-diagram">
    <div className="text-[11px] font-black uppercase tracking-[0.2em] text-orange-700 mb-2">The Rim Clock · use this for every question</div>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 items-center">
      <RimClockSvg />
      <img src={photoUrl} alt="Basketball rim from above with net hooks numbered like a clock" className="w-full h-auto rounded" data-testid="rim-clock-photo" />
    </div>
    <ul className="text-[12px] text-zinc-800 mt-3 space-y-1 list-disc pl-5" data-testid="rim-clock-key">
      <li><b>12 is the back iron</b> (against the backboard); <b>6 is the front rim</b> (closest to a shooter facing the basket).</li>
      <li>Each net hook is one hour: 12 hooks, so each hour apart is 360° ÷ 12 = <b>30°</b> at the center O.</li>
      <li>The shooter aims at the hour straight across. The aim line goes through O, so it is a <b>diameter</b> (18 in); half of it is a <b>radius</b> (9 in).</li>
      <li>Any segment between two hooks is a <b>chord</b>; the rim between them is an <b>arc</b>.</li>
    </ul>
  </div>
);
